import { DidomiSDK } from '@didomi/react';
import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';
import { TAppEnv } from '@mfe-types/env';

// public key/ids
const didomiApiKey = '149b0c39-206e-41db-b6fc-0e816b7577dd';

const didomiNoticeIds = {
    [Portal.SeLoger]: {
        development: 'Mjffjh7D',
        preview: 'Mjffjh7D',
        production: '69Z9Ytx6',
    },
    [Portal.LogicImmo]: {
        development: 'CKp7t4qM',
        preview: 'CKp7t4qM',
        production: 'yiDPMe9H',
    },
};

const DidomiUserConsent = ({
    portal,
    env,
}: {
    portal: Portal.LogicImmo | Portal.SeLoger;
    env: TAppEnv;
}) => {
    // We don't want to display the notice (auto-popup) in development/preview mode
    const config = {
        notice: {
            enable: !!(env && env !== 'development' && env !== 'preview'),
        },
    };
    return (
        <DidomiSDK
            config={config}
            iabVersion={2}
            apiKey={didomiApiKey}
            noticeId={didomiNoticeIds[portal][env ?? 'development']}
            gdprAppliesGlobally
            sdkPath="https://sdk.privacy-center.org/"
        />
    );
};

export default DidomiUserConsent;
